import router from "@/router";

const routes = router.options.routes;
//判断是否有权限访问该菜单
function hasPermission(menus: any, route: any) {
  if (route.name) {
    const currMenu = getMenu(route.name, menus);
    if (currMenu != null) {
      //设置菜单的标题、图标和可见性
      if (currMenu.title != null && currMenu.title !== "") {
        route.meta.title = currMenu.title;
      }
      if (currMenu.icon != null && currMenu.title !== "") {
        route.meta.icon = currMenu.icon;
      }
      if (currMenu.hidden != null) {
        route.hidden = currMenu.hidden !== 0;
      }
      if (currMenu.sort != null && currMenu.sort !== "") {
        route.sort = currMenu.sort;
      }
      return true;
    } else {
      route.sort = 0;
      if (route.hidden !== undefined && route.hidden === true) {
        route.sort = -1;
        return true;
      } else {
        return false;
      }
    }
  } else {
    return true;
  }
}

//根据路由名称获取菜单
function getMenu(name: any, menus: any) {
  for (let i = 0; i < menus.length; i++) {
    const menu = menus[i];
    if (name === menu.name) {
      return menu;
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters: any) {
  for (let i = 0; i < accessedRouters.length; i++) {
    const router = accessedRouters[i];

    if (router.children && router.children.length > 0) {
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p: any) {
  return function (m: any, n: any) {
    const a = m[p];
    const b = n[p];
    return b - a;
  };
}

const permission = {
  state: {
    routers: routes,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state: any, routers: any) => {
      state.addRouters = routers;
      state.routers = routers;
    },
  },
  actions: {
    GenerateRoutes({ commit }: any, data: any) {
      return new Promise<void>((resolve) => {
        const { menus } = data;
        const { username } = data;
        const accessedRouters = routes.filter((v) => {
          //admin帐号直接返回所有菜单
          // if(username==='admin') return true;
          if (hasPermission(menus, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter((child) => {
                if (hasPermission(menus, child)) {
                  return child;
                }
                return false;
              });
              return v;
            } else {
              return v;
            }
          }
          return false;
        });
        //对菜单进行排序
        sortRouters(accessedRouters);

        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    },
  },
};

export default permission;
